import { _, memoize } from '@api'

const uniqByProperty = {
  Boolean: 'boolVal',
  String: 'strVal',
  Float: 'floatVal',
  Int: 'intVal'
}

export const SpecificationService = {
  filter: memoize((data, filters) => {
    if (_.isEmpty(filters)) return data
    return _.filter(data, (d: any) => {
      let flag = false
      _.forEach(filters, filter => {
        const attribute: any = _.find(d.attributes, (attribute) => attribute.customAttributeDefinition.id === filter.name)
        if (filter.value.length) {
          flag = _.some(filter.value, val => {
            const nullFilterData = `${filter.title}_null` === val.value
            switch (filter.type) {
              case 'Boolean':
                return val.value === 'false' ? (!attribute || !attribute.boolVal) : (attribute && attribute.boolVal)
              case 'Tag':
                return (nullFilterData && (!attribute || !attribute.tag)) || (attribute && attribute.tag ? attribute.tag.id === val.value : false)
              case 'TagList':
                return (nullFilterData && (!attribute || !attribute.tagList || attribute.tagList.length === 0)) || (attribute && attribute.tagList && attribute.tagList.length ? _.find(attribute.tagList, (tag) => tag.id === val.value) : false)
              default:
                const attrValue = attribute ? attribute[uniqByProperty[filter.type]] : null
                return (nullFilterData && (!attribute || ( attrValue === null || attrValue === undefined || attrValue === ''))) || (attribute && val.value == attrValue)
            }
          })
        }
        return flag
      })
      return flag
    })
  })
}



// WEBPACK FOOTER //
// ./src/modules/libraries/services/SpecificationService.ts